import { render, staticRenderFns } from "./nodedit.vue?vue&type=template&id=127b6e9f&scoped=true&"
import script from "./nodedit.vue?vue&type=script&lang=js&"
export * from "./nodedit.vue?vue&type=script&lang=js&"
import style0 from "./nodedit.vue?vue&type=style&index=0&id=127b6e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b6e9f",
  null
  
)

export default component.exports